(() => {
  if (customElements.get('sca-refined-cart')) return;
  const roots = new Set();
  let busy = false, lastCart, revision = 0, timer;
  const cartRoot = () => window.Shopify?.routes?.root || '/';
  const forms = () => [...roots].flatMap(root => [...root.querySelectorAll('[data-scapd-form]')]);
  async function request(path, payload) {
    const options = { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } };
    if (payload) {
      options.method = 'POST';
      if (payload instanceof FormData) options.body = payload;
      else { options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(payload); }
    }
    const response = await fetch(cartRoot() + path, options);
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Le panier n’a pas pu être mis à jour. Merci de réessayer.');
    return data;
  }
  function quantity(cart, form) {
    return cart.items.filter(item => String(item.variant_id) === form.dataset.variantId && item.properties?._sca_gift !== 'musc35_2026').reduce((total, item) => total + item.quantity, 0);
  }
  function lock(locked) {
    forms().forEach(form => {
      const count = lastCart ? quantity(lastCart, form) : Number(form.querySelector('.scapd-quantity')?.textContent || 0);
      const maximum = Number(form.dataset.max || 0), step = count ? Number(form.dataset.increment || 1) : Number(form.dataset.min || 1);
      form.setAttribute('aria-busy', String(locked));
      form.querySelectorAll('button').forEach(button => {
        const minus = button.dataset.scapdDelta === '-1';
        button.disabled = locked || (minus ? count === 0 : form.dataset.available === 'false' || (maximum > 0 && count + step > maximum));
      });
      form.querySelectorAll('select').forEach(select => { select.disabled = locked; });
    });
  }
  function paint(cart) {
    lastCart = cart;
    forms().forEach(form => {
      const count = quantity(cart, form), output = form.querySelector('.scapd-quantity'), controls = form.querySelector('.scapd-in-cart');
      if (controls) {
        form.querySelector('.scapd-add').hidden = count > 0;
        controls.hidden = count === 0;
        output.textContent = String(count);
      }
    });
    if (!window.scentalyaCartCounter) document.querySelectorAll('.cart-count').forEach(counter => {
      counter.textContent = String(cart.item_count);
      counter.hidden = cart.item_count === 0;
      counter.style.setProperty('display', cart.item_count > 0 ? 'flex' : 'none', 'important');
    });
    lock(busy);
  }
  async function refresh() {
    if (busy) return;
    const current = ++revision;
    try { const cart = await request('cart.js'); if (!busy && current === revision) paint(cart); }
    catch (error) { console.warn('Scentalya : synchronisation du panier indisponible.', error); }
  }
  function schedule() { revision += 1; clearTimeout(timer); timer = setTimeout(refresh, 80); }
  async function change(form, delta) {
    if (busy) return;
    const errorBox = form.querySelector('.scapd-error');
    const data = new FormData(form);
    busy = true; revision += 1; lock(true); errorBox.hidden = true;
    try {
      const cart = await request('cart.js');
      const count = quantity(cart, form);
      if (delta > 0) {
        if (form.dataset.available === 'false') return;
        const step = count ? Number(form.dataset.increment || 1) : Number(form.dataset.min || 1);
        data.set('id', form.dataset.variantId); data.set('quantity', String(step));
        await request('cart/add.js', data);
        paint(await request('cart.js'));
      } else {
        const lines = cart.items.filter(item => String(item.variant_id) === form.dataset.variantId && item.properties?._sca_gift !== 'musc35_2026');
        const line = lines[lines.length - 1];
        if (line) {
          const reduced = line.quantity - Number(form.dataset.increment || 1);
          paint(await request('cart/change.js', { id: line.key, quantity: reduced < Number(form.dataset.min || 1) ? 0 : reduced }));
        } else paint(cart);
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: lastCart } }));
      const add = form.querySelector('.scapd-add');
      if (delta > 0 && add.hidden) form.querySelector('[data-scapd-delta="1"]')?.focus({ preventScroll: true });
      if (delta < 0 && !add.hidden) add.focus({ preventScroll: true });
    } catch (error) {
      errorBox.textContent = error.message || 'Impossible de modifier le panier. Merci de réessayer.';
      errorBox.hidden = false;
      try { paint(await request('cart.js')); } catch {}
    } finally { busy = false; lock(false); schedule(); }
  }
  function image(root, src, alt) {
    const target = root.querySelector('.scapd-main-image');
    if (!target || !src) return;
    target.removeAttribute('srcset'); target.src = src;
    if (alt) target.alt = alt;
    root.querySelectorAll('[data-scapd-image]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.scapdImage === src)));
  }
  function variant(root, selected) {
    const productId = selected.closest('form').dataset.productId;
    root.querySelectorAll('[data-scapd-form]').forEach(form => {
      if (form.dataset.productId !== productId) return;
      form.dataset.variantId = selected.value;
      for (const key of ['available', 'min', 'increment', 'max']) form.dataset[key] = selected.dataset[key];
      const input = form.querySelector('[name="id"]'); if (input) input.value = selected.value;
      const button = form.querySelector('.scapd-add');
      button.textContent = selected.dataset.available === 'true' ? root.dataset.addLabel : root.dataset.soldOutLabel;
      form.querySelector('.scapd-error').hidden = true;
    });
    root.querySelectorAll('[data-scapd-price]').forEach(price => { price.textContent = selected.dataset.price; });
    root.querySelector('[data-scapd-compare]')?.setAttribute('hidden', '');
    image(root, selected.dataset.image);
    const url = new URL(location.href); url.searchParams.set('variant', selected.value); history.replaceState({}, '', url);
    if (lastCart) paint(lastCart); lock(busy); schedule();
  }
  class RefinedCart extends HTMLElement {
    connectedCallback() {
      roots.add(this);
      this.controller?.abort(); this.controller = new AbortController();
      const signal = this.controller.signal;
      this.addEventListener('submit', event => {
        const form = event.target.closest('[data-scapd-form]');
        if (!form || !this.contains(form)) return;
        event.preventDefault(); event.stopImmediatePropagation(); change(form, 1);
      }, { signal, capture: true });
      this.addEventListener('click', event => {
        const delta = event.target.closest('[data-scapd-delta]');
        if (delta) { event.preventDefault(); change(delta.closest('form'), Number(delta.dataset.scapdDelta)); return; }
        const thumb = event.target.closest('[data-scapd-image]');
        if (thumb) { image(this, thumb.dataset.scapdImage, thumb.dataset.scapdAlt); return; }
        const arrow = event.target.closest('[data-scapd-scroll]');
        if (arrow) {
          const rail = this.querySelector('.scapd-carousel');
          rail?.scrollBy({ left: rail.clientWidth * Number(arrow.dataset.scapdScroll) * 0.8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          return;
        }
        if (event.target.closest('[data-scapd-rating]') && this.querySelector('[data-scapd-reviews]')) {
          event.preventDefault(); event.stopPropagation();
          this.openReviews();
        }
      }, { signal, capture: true });
      this.addEventListener('change', event => {
        if (event.target.matches('[data-scapd-variant]')) variant(this, event.target.selectedOptions[0]);
      }, { signal });
      this.addEventListener('toggle', event => {
        if (event.target.matches('[data-scapd-reviews]') && event.target.open) requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
      }, { signal, capture: true });
      const primary = this.querySelector('[data-scapd-primary-buy]'), sticky = this.querySelector('[data-scapd-sticky]');
      if (primary && sticky) {
        const builder = this.querySelector('sca-fondants-builder');
        const selector = primary.querySelector('[data-scapd-variant]');
        const destination = builder?.querySelector('.scamix-picker') || selector;
        if (destination && !sticky.querySelector('[data-scapd-choose]')) {
          const choose = document.createElement('button');
          choose.type = 'button';
          choose.className = 'scapd-button scapd-sticky-choose';
          choose.dataset.scapdChoose = '';
          choose.textContent = builder ? 'Choisir mes senteurs' : 'Choisir mes options';
          sticky.classList.add('scapd-sticky-options');
          sticky.appendChild(choose);
          choose.addEventListener('click', () => {
            destination.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
            const focusTarget = selector || destination.querySelector('button,select,input');
            focusTarget?.focus({ preventScroll: true });
          }, { signal });
        }
        this.stickyObserver?.disconnect();
        this.stickyObserver = new IntersectionObserver(entries => {
          sticky.hidden = entries[0].isIntersecting && entries[0].intersectionRatio >= 1;
        }, { threshold: 1, rootMargin: '0px 0px -80px 0px' });
        this.stickyObserver.observe(primary);
        const rect = primary.getBoundingClientRect();
        sticky.hidden = rect.top >= 0 && rect.bottom <= window.innerHeight - 80;
      }
      this.loadRecommendations();
      if (lastCart) paint(lastCart); lock(busy); schedule();
    }
    openReviews() {
      const target = this.querySelector('[data-scapd-reviews]');
      if (!target) return;
      if (target.tagName === 'DETAILS') target.open = true;
      target.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
    }
    async loadRecommendations() {
      if (!this.dataset.scapdRecommendations || this.dataset.scapdAuto !== 'true' || this.recommendationsLoaded) return;
      this.recommendationsLoaded = true;
      try {
        const response = await fetch(this.dataset.scapdRecommendations, { credentials: 'same-origin', signal: this.controller.signal });
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = doc.querySelector('[data-scapd-related-content]');
        if (content && content.querySelectorAll('.scapd-card').length) {
          const target = this.querySelector('[data-scapd-related-content]'); target.replaceChildren(...content.childNodes); target.hidden = false;
          if (lastCart) paint(lastCart); lock(busy); schedule();
        }
      } catch (error) { if (error.name !== 'AbortError') console.warn('Scentalya : recommandations indisponibles.', error); }
    }
    disconnectedCallback() { roots.delete(this); this.controller?.abort(); this.stickyObserver?.disconnect(); this.recommendationsLoaded = false; }
  }
  customElements.define('sca-refined-cart', RefinedCart);
  ['cart:updated', 'cart:refresh', 'cart:change'].forEach(name => document.addEventListener(name, schedule));
  ['pageshow', 'focus', 'online'].forEach(name => window.addEventListener(name, schedule));
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') schedule(); });
})();

